// Selectors for searchPublicCities
export const selectSearchCitiesData = (state) => state.publicCity.searchCities.data;
export const selectSearchCitiesLoading = (state) => state.publicCity.searchCities.loading;
export const selectSearchCitiesError = (state) => state.publicCity.searchCities.error;
